import React, { useState } from 'react';
import './AddDays.css';

function AddDays({ onAddDays }) {
  const [numberOfDays, setNumberOfDays] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {  // Remove async, we're just passing the number
    e.preventDefault();
    setError('');

    const numDays = parseInt(numberOfDays, 10);

    if (numDays > 0 && numDays <= 60) {
      try {
        onAddDays(numDays);  // Just pass the number to parent
        setNumberOfDays('');
      } catch (err) {
        setError('Please enter a valid number of days (1-60).');
      }
      setLoading(false);
    } else {
      setError('Please enter a valid number of days (1-60).');
    }
  };

  return (
    <div className="add-days">
      <h2>Add More Days</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <label htmlFor="numberOfDays">Number of days to add (1-60):</label>
          <input 
            type="number" 
            id="numberOfDays"
            value={numberOfDays} 
            onChange={(e) => setNumberOfDays(e.target.value)} 
            required 
            min="1"
            max="60"
            disabled={loading}
          />
        </div>
        <button type="submit" className="add-button" disabled={loading}>
          Add Days
        </button>
      </form>
    </div>
  );
}

export default AddDays;